import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.AddAsWatchersPopup', {
    title: 'Add as Watchers',
    description:
        'You have mentioned {number} user(s) who have no access to the request. Would you like to add them to Watchers?',
    postAndAdd: 'Post comment and add Watchers ({number})',
    post: 'Post comment',
    listHeader: 'USER',
});
